<template>
    <van-action-sheet
        :closeable="false"
        v-model="innerShowActions"
        :cancel-text="l.id_cancel_btn"
        class="action-sheet"
        :round="false"
    >
        <div class="action-btn-list">
            <div class="from-album" @click="clickKnow">
                <Uploader
                    :deletable="false"
                    :name="echoField"
                    preview-size="100%"
                    max-count="1"
                    :preview-full-image="false"
                    :before-read="beforeRead"
                    :after-read="afterRead"
                >
                    <template #default>{{
                        l.id_select_idcard_from_album
                    }}</template>
                </Uploader>
            </div>
            <div class="dividing van-hairline--top"></div>
            <div class="from-camera" @click="clickKnow">
                <Uploader
                    :deletable="false"
                    :name="echoField"
                    preview-size="100%"
                    max-count="1"
                    capture="camera"
                    :preview-full-image="false"
                    :before-read="beforeRead"
                    :after-read="afterRead"
                >
                    <template #default>{{
                        l.id_select_idcard_from_camera
                    }}</template>
                </Uploader>
            </div>
        </div>
    </van-action-sheet>
</template>

<script>
import Compressor from "compressorjs";
import { IMAGE_LIMIT } from "../../utils/config";
import { lrzUploadImage } from "../../services/upload";
import { Uploader, ActionSheet } from "vant";
import l from "../../locales";

export default {
    components: {
        Uploader,
        [ActionSheet.name]: ActionSheet,
    },
    props: {
        isClickClose: {
            type: Boolean,
            default: false,
        },
        showActions: {
            type: Boolean,
            default: false,
        },
        echoField: {
            type: String,
            default: "",
        },
    },
    watch: {
        showActions(newVal) {
            this.innerShowActions = newVal;
        },
        innerShowActions(newVal) {
            this.$emit("update:showActions", newVal);
        },
    },
    data() {
        return {
            l: l.idCard,
            innerShowActions: false,
        };
    },
    methods: {
        clickKnow() {
            // 点击知道了关闭弹窗
            if (this.isClickClose) {
                this.innerShowActions = false;
            }
        },
        // 图片修正
        beforeRead(file, detail, i = 1) {
            // console.log("beforeRead", file);
            // loading
            this.$emit("beforeRead", this.echoField);
            return new Promise((resolve) => {
                // compressorjs 默认开启 checkOrientation 选项
                let quality = 1;
                let len = IMAGE_LIMIT * (1024 * 1024);
                if (file.size > len) {
                    quality = 0.5 ** i;
                }
                // 会将图片修正为正确方向
                new Compressor(file, {
                    checkOrientation: true,
                    quality: quality,
                    success: async (result) => {
                        let nowFile = new File([result], result.name, {
                            type: file.type,
                        });
                        if (i >= 2) {
                            // console.log("2次压缩结束");
                            resolve(result);
                        } else if (result.size > len) {
                            resolve(
                                this.beforeRead(nowFile, detail, Number(i) + 1)
                            );
                        } else {
                            // console.log("成功压缩");
                            resolve(result);
                        }
                    },
                    error(err) {
                        console.log("beforeRead", err);
                    },
                });
            });
        },
        // 上传拦截
        afterRead(file) {
            let vm = this;
            // console.log("afterRead", file);
            lrzUploadImage(file.file,this.echoField, (results, url) => {
                vm.$emit("afterRead", results, vm.echoField, url);
                vm.innerShowActions = false;
            });
            return false;
        },
    },
};
</script>

<style lang="less" scoped>
.action-sheet {
    width: 92%;
    padding: 0 4%;
    background: rgba(0, 0, 0, 0);
    .van-action-sheet__gap {
        background: rgba(0, 0, 0, 0);
    }
    .van-action-sheet__cancel {
        background: #ffffff;
        height: 50px;
        border-radius: 10px;
        margin-bottom: 15px;
        font-family: PingFangSC-Medium;
        font-size: 15px;
        color: #00819F;
    }
    .action-btn-list {
        .dividing::after {
            background: #c6c6c6;
        }
        > div:first-child {
            background: #f0f0f0;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #00819F;
            height: 50px;
            line-height: 50px;
            text-align: center;
            margin-top: 15px;
            border-radius: 10px 10px 0 0;
        }
        > div:last-child {
            background: #f0f0f0;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #00819F;
            height: 50px;
            line-height: 50px;
            text-align: center;
            border-radius: 0 0 10px 10px;
        }
    }
}
</style>
